// Typelizer digest 9767031a629582fc4dd759835733d6d7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/sales_documents */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/sales_documents', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/sales_documents */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/sales_documents/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /c/:company_id/sales_documents/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/sales_documents/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/sales_documents/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:id', params, options),
    method: 'delete',
  }),
}
